import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomerState } from "./customer.state";
import {
  getCustomerInfo,
  updateProfile,
  updatePreferences,
  logoutDevice,
} from "./customer.thunk";
import { CustomerInfo } from "./customer.types";

const initialState: CustomerState = {
  data: null,
  status: "idle",
  error: null,
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    resetCustomer: (state) => {
      state.data = null;
    },
  },
  extraReducers: (build) => {
    build
      .addCase(getCustomerInfo.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getCustomerInfo.fulfilled,
        (state, action: PayloadAction<CustomerInfo>) => {
          state.status = "success";
          state.data = action.payload;
        },
      )
      .addCase(
        getCustomerInfo.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Bir hata oluştu.";
        },
      );

    build
      .addCase(updateProfile.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state) => {
        state.status = "success";
      })
      .addCase(
        updateProfile.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Profil güncellenemedi.";
        },
      );

    build
      .addCase(updatePreferences.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updatePreferences.fulfilled, (state) => {
        state.status = "success";
      })
      .addCase(
        updatePreferences.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Tercihler güncellenemedi.";
        },
      );

    build
      .addCase(logoutDevice.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(logoutDevice.fulfilled, (state) => {
        state.status = "success";
      })
      .addCase(
        logoutDevice.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Cihaz çıkışı yapılamadı.";
        },
      );
  },
});

export const { resetCustomer } = customerSlice.actions;
export default customerSlice.reducer;
